const REPUVE = process.env.REACT_APP_ENV_NAME === 'repuve';

export const getEnumValues = (_enum = {}) => Object.values(_enum);

export const solicitantesEnum = Object.freeze({
  CIUDADANO: 1,
  CONTRIBUYENTE: 15,
});

export const padronesEnum = Object.freeze({
  CIUDADANO: 1,
  EMPRESA: 2,
  PREDIO: 3,
  VEHICULO: 4,
  HOSPEDAJE: 6,
  ARRENDAMIENTO: 7,
  NOMINA: 8,
  ALCOHOL: 9,
  CEDULAR: 10,
  JUEGO_DE_AZAR: 11,
  NOTARIO: 12,
  CASA_DE_EMPENIO: 13,
  AGENCIA: 14,
  CONTRIBUYENTE: 15,
  MOTOCICLETA: 16,
  REMOLQUE: 17,
  POLICIA_ESPECIAL: 18,
  INFRACCIONES: 19,
  COMERCIO_INFORMAL: 20,
  MERCADO: 21,
  EXPEDIENTE_LICENCIA_FUNCIONAMIENTO: 22,
  ZONA_EXCLUSIVA: 23,
  EXPEDIENTE_DE_ANUNCIO: 24,
  MULTAS: 25,
  VENDEDOR_DE_ALCOHOLES: 26,
  RETENEDOR_DE_CEDULA: 27,
  RETENEDOR_DE_NOMINA: 28,
  SERVICIO_PUBLICO: 29,
  ESTACIONAMIENTO: 30,
  LOTES_DE_PANTEON: 31,
  MODULOS: 32,
});

export const stepsEnum = Object.freeze({
  PADRON_SOLICITANTE: 'PADRON_SOLICITANTE',
  PADRON_AFECTADO: 'PADRON_AFECTADO',
  REQUISITOS_GENERALES: 'REQUISITOS_GENERALES',
  CASOS_DE_REQUISITOS: 'CASOS_DE_REQUISITOS',
  REQUISITOS_DEL_CASO: 'REQUISITOS_DEL_CASO',
  VARIABLES: 'VARIABLES',
  GENERAR_CARGOS: 'GENERAR_CARGOS',
});

export const saveLabelEnum = Object.freeze({
  CONTINUE: 'Continuar',
  SAVE: 'Guardar',
  GENERATE_CHARGES: 'Generar Cargos',
  START_TRAMITE: 'Iniciar trámite',
  FINISH: 'Finalizar trámite',
  AUTHORIZE: 'Autorizar',
  SIGN: 'Firmar',
  // SYNC_FINANZAS: 'Consultar finanzas',
  NOT_SUPPORTED: null,
});

export const afectacionesEnum = Object.freeze({
  ALTA: 1,
  MODIFICACION: 2,
  BAJA: 3,
  CONSULTA: 4,
});

export const aplicacionesCargosEnum = Object.freeze({
  CAPTURABLE: 1,
  FIJO: 2,
  TARIFA: 3,
  FORMULA: 4,
  MULTIPLO: 5,
  PORCENTAJE: 6,
  SQL_FUNCTION: 7,
});

export const tiposDatosFormulaEnum = Object.freeze({
  ENTERO: 1,
  DECIMAL: 2,
  RANGO_DE_FECHAS: 3,
});

export const tiposDatosEnum = Object.freeze({
  ENTERO: 4,
  DECIMAL: 5,
  RANGO_DE_FECHAS: 6,
  FECHA: 7,
  FECHA_HORA: 8,
  BOOLEAN: 9,
  TEXTO_CORTO: 10,
  TEXTO_LARGO: 11,
  SELECCION_UNICA: 12,
  SELECCION_MULTIPLE: 13,
  TABLA: 14,
});

export const dataTypesEnum = Object.freeze({
  CHAR: 'CharField',
  TEXT: 'TextField',
  DECIMAL: 'DecimalField',
  FLOAT: 'FloatField',
  DATE: 'DateField',
  TIME: 'TimeField',
  DATE_TIME: 'DateTimeField',
  INTEGER: 'IntegerField',
  POSITIVE_INTEGER: 'PositiveIntegerField',
  POSITIVE_BIG_INTEGER: 'PositiveBigIntegerField',
  POSITIVE_SMALL_INTEGER: 'PositiveSmallIntegerField',
  SMALL_INTEGER: 'SmallIntegerField',
  BIG_INTEGER: 'BigIntegerField',
  BOOLEAN: 'BooleanField',
  SLUG: 'SlugField',
  FOREIGN_KEY: 'related.ForeignKey',
  MANY_TO_MANY: 'related.ManyToManyField',
  URL: 'URLField',
  EMAIL: 'EmailField',
  IMAGE: 'files.ImageField',
});

export const statusRequisitosEnum = Object.freeze({
  NEED_UPDATE: 'NEED_UPDATE',
  INCOMPLETE: 'INCOMPLETE',
  COMPLETE: 'COMPLETE',
  CONTINUE: 'CONTINUE',
  AUTORIZED: 'AUTORIZED',
});

export const tiposDeRequisitosEnum = Object.freeze({
  OBLIGATORIO: 1,
  OPCIONAL: 2,
  EXCLUSIVO: 3,
  INCLUSIVO: 4,
  DINAMICO: 5,
});

export const tiposDePasosEnum = Object.freeze({
  VALIDACION: 1,
  EMISION_DE_DOCUMENTO: 2,
  FIRMA_ELECTRONICA: 3,
  GIS: 4,
  VARIABLES: 5,
  MODIFICACION_SOLICITANTE: 6,
  MODIFICACION_AFECTADO: 7,
  VALIDACION_REQUISITOS: 8,
  CAMBIO_DE_PROPIETARIO: 9,
  REQUISITOS: 10,
  CARGOS: 11,
  ALTA_AFECTADO: 12,
  DIRECCION_PRINCIPAL: 13,
  DIRECCION_SECUNDARIA: 14,
  OBLIGACIONES: 15,
  EMPRESAS: 16,
  PARTICIPES: 17,
  FOTOGRAFIA: 18,
  CONSTRUCCIONES: 19,
  ACTIVIDADES_ECONOMICAS: 20,
  ACTIVIDADES_ECONOMICAS_SAT: 21,
  CONTRIBUYENTES_VINCULADOS: 22,
  CARGA_DE_DOCUMENTO: 23,
  VISTA_PADRON: 24,
  CITA: 25,
  ASIGNACION_CONSTANCIA: REPUVE ? 58 : 26,
  SINCRONIZACION_DE_DATOS_FINANZAS: REPUVE ? 59 : 27,
  BAJA_EMPRESA: 28,
  AFECTAR_PADRON_JSON: 29,
  SUBDIVISION: 30,
  FUSION: 31,
  AVALUO_TERRENO: 32,
  COLINDANCIAS: 33,
  AREAS_COMUNES_DE_PREDIOS: 34,
  VALORES_REFERIDOS_DE_PREDIOS: 35,
  ALERTAS: 36,
});

export const periodosMap = Object.freeze({
  EVENTUAL: 1,
  DIARIO: 2,
  SEMANAL: 3,
  QUINCENAL: 4,
  MENSUAL: 5,
  BIMESTRAL: 6,
  TRIMESTRAL: 7,
  CUATRIMESTRAL: 8,
  SEMESTRAL: 9,
  ANUAL: 10,
});

export const padronesModelsEnum = Object.freeze({
  [padronesEnum.CIUDADANO]: 'ciudadano',
  [padronesEnum.EMPRESA]: 'empresa',
  [padronesEnum.PREDIO]: 'predio',
  [padronesEnum.VEHICULO]: 'vehiculo',
  [padronesEnum.HOSPEDAJE]: 'hospedaje',
  [padronesEnum.ARRENDAMIENTO]: 'arrendamiento',
  [padronesEnum.NOMINA]: 'nomina',
  [padronesEnum.ALCOHOL]: 'alcohol',
  [padronesEnum.CEDULAR]: 'cedular',
  [padronesEnum.JUEGO_DE_AZAR]: 'juegodeazar',
  [padronesEnum.NOTARIO]: 'notario',
  [padronesEnum.CASA_DE_EMPENIO]: 'casadeempenio',
  [padronesEnum.AGENCIA]: 'agencia',
  [padronesEnum.CONTRIBUYENTE]: 'contribuyente',
  [padronesEnum.MOTOCICLETA]: 'motocicleta',
  [padronesEnum.REMOLQUE]: 'remolque',
  [padronesEnum.POLICIA_ESPECIAL]: 'contratodepolicia',
  [padronesEnum.INFRACCIONES]: 'infraccion',
  [padronesEnum.COMERCIO_INFORMAL]: 'expedientedecomercioinformal',
  [padronesEnum.MERCADO]: 'expedientedemercado',
  [padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO]: 'expedientedelicenciafuncionamiento',
  [padronesEnum.ZONA_EXCLUSIVA]: 'zonaexclusiva',
  [padronesEnum.EXPEDIENTE_DE_ANUNCIO]: 'expedientedeanuncio',
  [padronesEnum.MULTAS]: 'multa',
  [padronesEnum.VENDEDOR_DE_ALCOHOLES]: 'ventadealcohol',
  [padronesEnum.RETENEDOR_DE_CEDULA]: 'retenedorcedular',
  [padronesEnum.RETENEDOR_DE_NOMINA]: 'retenedordenomina',
  [padronesEnum.SERVICIO_PUBLICO]: 'serviciopublico',
  [padronesEnum.ESTACIONAMIENTO]: 'estacionamiento',
  [padronesEnum.LOTES_DE_PANTEON]: 'lotedepanteon',
  [padronesEnum.MODULOS]: 'expedientemodulodemercado',
});

export const procedenciasEnum = Object.freeze({
  LAYOUT: 3,
  GPM: 7,
});

export const tipoDeDocumentoExpedienteEnum = Object.freeze({
  FOTOGRAFIA: 1,
  GIS: 2,
  DOCUMENTO: 3,
  RECIBO: 4,
  ACUSE_VARIABLES: 5,
  ANEXO_CANCELACION: 6,
});

export const direccionPrincipalEnum = Object.freeze({
  [padronesEnum.EMPRESA]: 'direccion_de_ubicacion',
  [padronesEnum.PREDIO]: 'direccion',
  [padronesEnum.CONTRIBUYENTE]: 'direcciones',
  [padronesEnum.INFRACCIONES]: 'direccion_del_infractor',
  [padronesEnum.COMERCIO_INFORMAL]: 'expedientedecomercioinformal',
  [padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO]: 'expedientedelicenciafuncionamiento',
  [padronesEnum.MULTAS]: 'direccion_multa',
});

export const direccionSecundariaEnum = Object.freeze({
  [padronesEnum.PREDIO]: 'direccion_notificacion',
  [padronesEnum.CONTRIBUYENTE]: 'direcciones_de_notificacion',
  [padronesEnum.INFRACCIONES]: 'direccion_de_infraccion',
  [padronesEnum.MULTAS]: 'direccion_notificacion_multa',
});

export const estatusEnvioWs = Object.freeze({
  PENDIENTE: 1,
  ERROR_DATOS: 34,
  ERROR_5030: 35,
  ERROR_5031: 36,
  ERROR_NO_PROCEDE: 37,
  ACTUALIZADO: 38,
});

export const tiposDeContribuyentesSolicitantesEnum = Object.freeze({
  NOTARIO: 1,
  PERITO: 2,
  AUTORIDAD_EXTERNA: 3,
});
